module.exports = {
  locales: ['en', 'de', 'es', 'fr'],
  defaultLocale: 'en',
  pages: {
    '*': ['common'],
  },
};
